import React from 'react';
import {Heading} from '../../components/guide/Heading';
import HeroBanner from "../../components/guide/HeroBanner";
import BannerImg from "../../assets/images/banner/guide_banner_3.png";
import CtaBanner from "../../components/guide/CtaBanner";
import {cn} from "../../utils/helper";
import RightArrowIcon from "../../assets/images/icon/right_arrow_icon.svg";
import BoxIcon1 from "../../assets/images/card/creative_box_icon_1.png";
import BoxIcon2 from "../../assets/images/card/creative_box_icon_2.png";

const CreativeGuidePage: React.FC = () => (
    <section className="w-full bg-white">
        <HeroBanner image={BannerImg} message="미분양 브랜딩부터, 현장 완판까지!"/>

        <div className="mx-auto w-full max-w-[1072px] px-0 sm:px-6 lg:px-0">
            <div className="space-y-6 lg:space-y-8">
                <Heading className="hidden lg:block lg:mt-[93px] lg:mb-[96px]" as="h1" size="h1">
                콘텐츠 제작
            </Heading>

                <Heading as="p" size="subtitle" className="text-black font-[600]">
                    “시선을 멈추게 하고, 브랜드를 기억에 남기는 콘텐츠 설계”
                </Heading>

                <Heading as="p" size="subtitle" className="text-black font-[400]">
                    업계 최초의 전문 아트디자인팀, 업계 최다의 디자이너 인력.<br/>
                    <br/>
                    분양의신은 수백, 수천 건의 실험과 플랫폼별 알고리즘 분석을 통해 성과가 나오는 디자인을 과학적으로 제작합니다.<br/>
                    광고 한 컷, 영상 몇 초, 홈페이지 한 화면에도 기준과 근거, 성과의 구조가 있습니다.<br/>
                    <br/>
                    우리는 보기 좋은 이미지보다, 팔리는 콘텐츠를 만듭니다.<br/>
                    그게 우리가 콘텐츠를 단순한 제작이 아닌 ‘설계’라고 부르는 이유입니다.
                </Heading>
            </div>

            {/* Cards */}
            <div className="mb-16 mt-10 grid grid-cols-1 gap-3 sm:grid-cols-2 sm:gap-4 lg:mb-[93px] lg:mt-[93px]">
                <a
                    href={'/guide/content/banner'}
                    className={cn(
                        'group relative block rounded-xl bg-[#F5F5F5] p-4 sm:p-6',
                        'hover:border-gray-300 hover:shadow-soft transition',
                    )}
                >
                    <div className="flex items-center gap-4">
                        <div className="flex h-9 w-9 items-center justify-center rounded-full">
                            <img src={BoxIcon1} alt="배너 & 홈페이지 콘텐츠" />
                        </div>
                        <div className="text-[15px] font-[600] md:font-[400] text-black sm:text-[20px]">배너 & 홈페이지 콘텐츠</div>
                        <div className="ml-auto">
          <span
              className="inline-flex h-8 w-[14px] md:w-8 items-center justify-center rounded-full md:bg-gray-50 text-gray-500 group-hover:bg-gray-100">
                <img src={RightArrowIcon} alt="" />
          </span>
                        </div>
                    </div>
                </a>
                <a
                    href={'/guide/content/cf'}
                    className={cn(
                        'group relative block rounded-xl bg-[#F5F5F5] p-4 sm:p-6',
                        'hover:border-gray-300 hover:shadow-soft transition',
                    )}
                >
                    <div className="flex items-center gap-4">
                        <div className="flex h-9 w-9 items-center justify-center rounded-full">
                            <img src={BoxIcon2} alt="분양의신 CF 배너 시스템" />
                        </div>
                        <div className="text-[15px] font-[600] md:font-[400] text-black sm:text-[20px]">분양의신 CF 배너 시스템</div>
                        <div className="ml-auto">
          <span
              className="inline-flex h-8 w-[14px] md:w-8 items-center justify-center rounded-full md:bg-gray-50 text-gray-500 group-hover:bg-gray-100">
                <img src={RightArrowIcon} alt="" />
          </span>
                        </div>
                    </div>
                </a>
            </div>

            <CtaBanner
                message="팔리는 콘텐츠, 우리 현장에선 어떻게 만들까요?"
                buttonText="광고문의 바로가기 →"
                href="https://분양의신.net/contact"
            />
        </div>
    </section>
);

export default CreativeGuidePage;
